export default __webpack_public_path__ + "static/media/plus-navy.6e13c5a3.svg";